(function() {
  let stepSwiperss = [];

  function initSwiper() {
    const sliders = document.querySelectorAll(".steps-swiper");

    if (window.innerWidth < 768) {
      sliders.forEach((slider, index) => {
        if (!stepSwiperss[index]) {
          stepSwiperss[index] = new Swiper(slider, {
            slidesPerView: 1.6,
            spaceBetween: 15,
            centeredSlides: false,
            freeMode: { enabled: true },
          });
        }
      });

    } else {
      stepSwiperss.forEach((swiper, index) => {
        if (swiper) {
          swiper.destroy(true, true);
          stepSwiperss[index] = null;
        }
      });
    }
  }

  initSwiper();
  window.addEventListener("resize", initSwiper);
})();
